import React from 'react';
import { useInView } from 'react-intersection-observer';
import FadeInAnimation from './FadeInAnimation';

export default function HomepageReveal({ children, delay = 0 }) {
  const [ref, inView] = useInView({ triggerOnce: true, rootMargin: '0px 0px -32px 0px', threshold: 0 });
  return <div ref={ref}><FadeInAnimation duration={0.65} yOffset={20} easing={[0.22, 1, 0.36, 1]} delaySeconds={delay} inView={inView}>{children}</FadeInAnimation></div>;
}
